import { z } from 'zod';

// v1.7 client feedback survey. The six questions ship verbatim from the legacy
// deck; structured answers are stored as comparable per-sprint values for the
// v2 dashboard/AI work. Responses are insert-only — there is no update DTO.

export const surveyCompetitionPositionSchema = z.enum([
  'below',
  'equal',
  'above',
]);
export type SurveyCompetitionPosition = z.infer<
  typeof surveyCompetitionPositionSchema
>;

export const surveyYesMaybeNoSchema = z.enum(['yes', 'maybe', 'no']);
export type SurveyYesMaybeNo = z.infer<typeof surveyYesMaybeNoSchema>;

const surveyOpenTextSchema = z.string().trim().max(2000).optional();

// Public POST body. Names render in the Edit UI and open text is a public
// write, so both carry hard caps.
export const SubmitSurveyResponseDTO = z.object({
  respondentName: z.string().trim().min(1).max(120),
  isDecisionMaker: z.boolean(),
  strategistAssisted: z.boolean(),
  q1CreativeLiked: surveyOpenTextSchema,
  q2CompetitionPosition: surveyCompetitionPositionSchema.optional(),
  q3CreativeQuestions: surveyOpenTextSchema,
  q4WouldRenew: surveyYesMaybeNoSchema.optional(),
  q5BetterExperience: surveyOpenTextSchema,
  q6WouldRecommend: surveyYesMaybeNoSchema.optional(),
});
export type SubmitSurveyResponse = z.infer<typeof SubmitSurveyResponseDTO>;

// Public GET :token response — enough for the form's header and nothing else.
export interface SurveyFormInfo {
  businessName: string;
}

// The packet's survey, as far as the client is concerned: one link.
//
// Since slice 11 the survey lives in Salesforce (`Link_to_Sprint_Survey__c` on
// the business's SF Account), snapshotted onto the packet at create. Responses
// land there too, so there is no response status left to report and no expiry of
// ours to publish. `null` means no link is saved — Present hides the survey
// slide, Edit shows a dimmed card with a Refresh button.
export interface SprintPacketSurveyStatus {
  link: string | null;
}
